export default __webpack_public_path__ + "static/media/Chousath-Yogini-Temple-1.29f165e6.jpg";